import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 11 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M.359 2.09 6.71 8.442H2.484a1.278 1.278 0 1 0 0 2.558h7.18C10.4 11 11 10.401 11 9.665v-7.18a1.28 1.28 0 0 0-1.279-1.279 1.28 1.28 0 0 0-1.279 1.28V6.71L2.091.358A1.22 1.22 0 0 0 1.225 0a1.224 1.224 0 0 0-.866 2.09" }, null, -1)
  ]))]))
}
export default { render: render }